import React, { useEffect, useState } from "react";
import CvantoAIVisual from "./CvantoAIVisual";
import VoiceActionMenu from "./VoiceActionMenu";
import SearchPromptInput from "./SearchPromptInput";
import "./SearchHero.scss";

// Cvanto Search Phase 7 — this component now owns ONLY the ordinary search
// input plus the orb entry point into Cvanto AI Search. It no longer holds
// any AI state (no useCvantoAssistant instance here anymore, no inline
// interpretation panel) — that entire flow lives in CvantoAISearchModal,
// mounted by SearchResults.js and opened via `onOpenAI`. Ordinary typing
// (searchQuery/onSearchChange/onSearchKeyDown) is untouched, unrelated
// existing debounced search, and never mixes with the AI text.
const SearchHero = ({
  inputRef,
  searchQuery,
  onSearchChange,
  onSearchKeyDown,
  category,
  subscribed,
  subBusy,
  subAnim,
  onToggleSub,
  username,
  activeTab,
  onOpenAI,
}) => {
  const [quickActionsOpen, setQuickActionsOpen] = useState(false);

  // Closing on tab-switch is one of the explicit "menu must close" cases —
  // pointerdown/scroll/Escape are handled inside VoiceActionMenu itself,
  // this is the one trigger that comes from a sibling (SearchModeHeader),
  // several components away, rather than from inside the menu's own DOM.
  useEffect(() => {
    setQuickActionsOpen(false);
  }, [activeTab]);

  const handleMicTap = () => {
    setQuickActionsOpen(false);
    onOpenAI?.("voice");
  };

  // Phase 7's exact fix: keyboard opens the separate Cvanto AI Search
  // experience — it no longer focuses the ordinary input at all.
  const handleKeyboardTap = () => {
    setQuickActionsOpen(false);
    onOpenAI?.("text");
  };

  const handleOrbTap = () => setQuickActionsOpen((open) => !open);

  const handleClear = () => onSearchChange("");

  const greeting = username
    ? `Привіт, ${username}. Що шукаємо сьогодні?`
    : "Що шукаємо сьогодні?";

  return (
    <div className="search-hero-v2">
      <div className="search-hero-v2__orb-wrap">
        <VoiceActionMenu
          open={quickActionsOpen}
          onMic={handleMicTap}
          onKeyboard={handleKeyboardTap}
          onRequestClose={() => setQuickActionsOpen(false)}
        />

        <CvantoAIVisual state="idle" onTap={handleOrbTap} label="Cvanto AI Search" />
      </div>

      <div className="search-hero-v2__greeting">{greeting}</div>

      <SearchPromptInput
        ref={inputRef}
        value={searchQuery}
        onChange={onSearchChange}
        onKeyDown={onSearchKeyDown}
        onClear={handleClear}
        category={category}
        subscribed={subscribed}
        subBusy={subBusy}
        subAnim={subAnim}
        onToggleSub={onToggleSub}
      />
    </div>
  );
};

export default SearchHero;
